var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"image-stack",attrs:{"data-count":_vm.images.length}},_vm._l((_vm.images),function(url){return _c('img',{key:url,attrs:{"src":url},on:{"load":function($event){return _vm.imageLoaded(url)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }